<template>
    <v-card>
        <v-card-title class="headline secondary--text pb-0">Faça login para continuar</v-card-title>
        <v-card-title class="headline title font-weight-light pb-0">Nós usamos um sistema de login para entregar a melhor experiência, conforto e segurança.</v-card-title>
        <v-card-title class="subheading font-weight-light pb-1">Para continuar, clique no botão abaixo.</v-card-title>
        <v-card-actions>
            <v-btn flat block color="success lighten-1" @click="$router.push('/')">
                Concluir
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
  data () {
    return {}
  }
}
</script>
